import initialSyncfoniaState from "../phototool.initialState";
import { FAILURE, LOADING, SUCCESS } from "_constants/redux.constants";
import { reduxActions as SYNCFONIA } from '../../phototool.constants';

const pc9 = {
  [SYNCFONIA.UPDATE_GTIN_STARTED]: (state) => ({
    ...state,
    pc9: {
      ...state.pc9,
      status: LOADING
    }
  }),
    
  [SYNCFONIA.UPDATE_GTIN_FAIL]: (state, { payload }) => ({
    ...state,
    pc9: {
      ...state.pc9,
      error: payload?.error ?? null,
      status: FAILURE
    }
  }),
    
  [SYNCFONIA.UPDATE_GTIN_SUCCESS]: (state, { payload }) => ({
    ...state,
    pc9: {
      ...state.pc9,
      data: payload?.data ?? null,
      status: SUCCESS
    }
  }),
  [SYNCFONIA.UPDATE_GTIN_RESET]: (state) => ({
    ...state,
    pc9: initialSyncfoniaState.pc9
  })
};

export default pc9;
